<template>
  <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-5 md:tw-mt-10 tw-pb-5">
    <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
      Instalment Payment
      <hr class="tw-mt-4">
    </h3>
    <div class="tw-w-full tw-flex tw-flex-col">
      <div
          v-for="(instalment, index ) in installments"
          :key="index"
          class="tw-w-full tw-flex tw-justify-center tw-my-2 md:tw-my-4"
      >
        <v-card class="tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
          <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
            <p class="c-gray-text">{{ getInstallmentOrdinal(index+1) }}</p>
            <h1 class="tw-w-full c-gray-text tw-font-bold tw-text-6xl">{{ getMonth(index) }}</h1>
            <p class="tw-w-full c-gray-text tw-text-base">instalment</p>
          </div>
          <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
            <h4 class="c-blue-text tw-font-bold tw-text-sm">Payable Amount</h4>
            <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ instalment && instalment.premium ? instalment.premium : 0 | formatNum }}</h3>
            <v-btn
                v-if="index === 0"
                color="secondary"
                class="tw-mt-2" large block
                :loading="loading1"
                @click="$emit('proceed', instalment && instalment.premium ? instalment.premium : 0, 40)"
            >
              Confirm and Pay
            </v-btn>
            <h4 v-else class="c-blue-text tw-font-bold tw-text-base tw-mt-2">Due {{ addMonths(index) }}</h4>
          </div>
        </v-card>
      </div>
    </div>
  </v-card>
</template>

<script>
import helpers from '@/utils/helpers';
import { addMonths, getMonth } from '@/utils/time';

export default {
  name: 'BimaBambaInstallments',
  props: {
    coverType: Object,
    installments: Array,
    premiumAmount: Number,
  },
  data() {
    return {
      loading: false,
      loading1: false,
      pageLoading: false,
    };
  },
  methods: {
    addMonths,
    getMonth,

    getInstallmentOrdinal(index) {
      let ordinal = null;
      switch (index) {
        case 1: ordinal = 'st';
          break;
        case 2: ordinal = 'nd';
          break;
        case 3: ordinal = 'rd';
          break;
        default: ordinal = 'th';
      }

      return `${index}${ordinal} instalment`;
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
